import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'emp-loader',
  templateUrl: './loader.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent {}
